export var OrgaoResponsavelEnum;
(function (OrgaoResponsavelEnum) {
    OrgaoResponsavelEnum["CODEMAT"] = "CODEMAT";
    OrgaoResponsavelEnum["INTERMAT_DTC"] = "INTERMAT_DTC";
    OrgaoResponsavelEnum["DEP_TERRAS_MINAS_COLONIZACAO"] = "DEP_TERRAS_MINAS_COLONIZACAO";
    OrgaoResponsavelEnum["DEP_TERRAS_OBRAS_PUB"] = "DEP_TERRAS_OBRAS_PUB";
    OrgaoResponsavelEnum["DEP_TERRAS_COLONIZACAO"] = "DEP_TERRAS_COLONIZACAO";
    OrgaoResponsavelEnum["CONPANHIA_PLAN_PROD"] = "CONPANHIA_PLAN_PROD";
    OrgaoResponsavelEnum["SECRETARIA_AGRI"] = "SECRETARIA_AGRI";
    OrgaoResponsavelEnum["PODER_LEGISLA"] = "PODER_LEGISLA";
})(OrgaoResponsavelEnum || (OrgaoResponsavelEnum = {}));
(function (OrgaoResponsavelEnum) {
    var mapDescricao = new Map([
        [OrgaoResponsavelEnum.CODEMAT, 'CODEMAT - Companhia de Desenvolvimento do Estado de Mato Grosso'],
        [OrgaoResponsavelEnum.INTERMAT_DTC, 'INTERMAT - Instituto de Terras de Mato Grosso'],
        [OrgaoResponsavelEnum.DEP_TERRAS_MINAS_COLONIZACAO, 'DTMC - Departamento de Terras, Minas e Colonização'],
        [OrgaoResponsavelEnum.DEP_TERRAS_OBRAS_PUB, 'DTOP - Departamento de Terras e Obras Públicas'],
        [OrgaoResponsavelEnum.DEP_TERRAS_COLONIZACAO, 'DTC - Departamento de Terras e Colonização'],
        [OrgaoResponsavelEnum.CONPANHIA_PLAN_PROD, 'CPP - Companhia de Planejamento de Produção'],
        [OrgaoResponsavelEnum.SECRETARIA_AGRI, 'Secretaria de Agricultura - Departamento Geografia e Geologia'],
        [OrgaoResponsavelEnum.PODER_LEGISLA, 'Poder Legislativo'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    OrgaoResponsavelEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    OrgaoResponsavelEnum.getOptions = getOptions;
})(OrgaoResponsavelEnum || (OrgaoResponsavelEnum = {}));
